import React, { ReactNode } from 'react';
import { SimpleBlock, Text } from 'ui-builder';
import styles from './ColumnLayout.module.scss';

export function ColumnLayout(
  props: {
    className?: string,
    children: React.ReactNode,
  }
) {
  const children = React.Children.toArray(props.children);

  const getLabel = (child: ReactNode) => {
    if (React.isValidElement(child) && child.props.label) {
      return child.props.label;
    }
    return null;
  };

  return (
    <SimpleBlock className={styles.column}>
      {children.map((child, index) => {
        const label = getLabel(child);

        return (
          <SimpleBlock key={`column-layout-${index}`}>
            {label ? (
              <SimpleBlock>
                <Text bold>
                  {label}
                </Text>
              </SimpleBlock>
            ) : null}
            {child}
          </SimpleBlock>
        );
      })}
    </SimpleBlock>
  );
}
